"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DocCsv_exports = {};
__export(DocCsv_exports, {
  default: () => DocCsv_default
});
module.exports = __toCommonJS(DocCsv_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00002 5.0999C7.22683 5.0999 6.60002 5.7267 6.60002 6.4999V9.4999C6.60002 9.83127 6.3314 10.0999 6.00002 10.0999C5.66865 10.0999 5.40002 9.83127 5.40002 9.4999V6.4999C5.40002 5.06396 6.56408 3.8999 8.00002 3.8999H14.6134C15.0114 3.8999 15.3952 4.04826 15.6897 4.316L18.0763 6.48564C18.4099 6.78888 18.6 7.21875 18.6 7.66955V9.4999C18.6 9.83127 18.3314 10.0999 18 10.0999C17.6687 10.0999 17.4 9.83127 17.4 9.4999V8.75H15C14.1716 8.75 13.5 8.07843 13.5 7.25V5.0999H8.00002ZM14.5 5.0999V7.25C14.5 7.52614 14.7239 7.75 15 7.75H17.4V7.66955C17.4 7.55685 17.3525 7.44938 17.2691 7.37357L14.8825 5.20393C14.8089 5.13699 14.7129 5.0999 14.6134 5.0999H14.5ZM0.41333 15.752C0.41333 18.464 2.39333 20.18 4.76933 20.18C7.15733 20.18 8.38133 18.596 8.70533 17.288L7.15733 16.82C6.92933 17.612 6.22133 18.56 4.76933 18.56C3.40133 18.56 2.12933 17.564 2.12933 15.752C2.12933 13.82 3.47333 12.908 4.74533 12.908C6.22133 12.908 6.88133 13.808 7.08533 14.624L8.64533 14.132C8.30933 12.752 7.09733 11.312 4.74533 11.312C2.46533 11.312 0.41333 13.04 0.41333 15.752ZM13.8174 13.976L15.3054 13.52C15.1134 12.56 14.3214 11.312 12.2574 11.312C10.6494 11.312 9.29339 12.464 9.29339 13.976C9.29339 15.26 10.1694 16.136 11.5254 16.412L12.7134 16.652C13.3734 16.784 13.7454 17.168 13.7454 17.66C13.7454 18.26 13.2534 18.704 12.3654 18.704C11.1654 18.704 10.5774 17.948 10.5054 17.108L8.96939 17.516C9.10139 18.728 10.0974 20.18 12.3534 20.18C14.3334 20.18 15.4254 18.86 15.4254 17.552C15.4254 16.352 14.5974 15.344 13.0494 15.044L11.8614 14.816C11.2374 14.696 10.9374 14.324 10.9374 13.856C10.9374 13.292 11.4654 12.776 12.2694 12.776C13.3494 12.776 13.7334 13.508 13.8174 13.976ZM19.4684 17.816L21.6884 11.492H23.4404L20.2844 20H18.5804L15.4364 11.492H17.2484L19.4684 17.816Z",
      fill: "currentColor"
    }
  )
);
const SvgDocCsv = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DocCsv_default = SvgDocCsv;
